import { sendTestMatomoEvent } from "./matomoTest";

// Home screen analytics (Animated Grid)

export const sendHomeEvent = async (
  playlistType,
  currentRow,
  selectedItem,
  data
) => {
  const rowTitle = data[currentRow]?.title[0]?.content;
  const rowId = data[currentRow]?.id;

  console.log(playlistType, selectedItem, data, rowId, "playlistType");

  switch (playlistType) {
    case "tags":
      await sendTestMatomoEvent({
        eventCategory: "TagPage",
        eventAction: "View",
        eventName: `${rowId}/${rowTitle}`,
      });

      await sendTestMatomoEvent({
        eventCategory: "Tag",
        eventAction: "List",
        eventName: `${rowId}/${rowTitle}`,
      });
      break;

    case "popular_genres":
      await sendTestMatomoEvent({
        eventCategory: "Home",
        eventAction: "Select",
        eventName: `Popular Generes(${selectedItem?.title})`,
      });
      await sendTestMatomoEvent({
        eventCategory: "PopularGenres",
        eventAction: "ContentSelected",
        eventName: `Popular Generes(${selectedItem?.id}/${selectedItem?.title})`,
      });

      await sendTestMatomoEvent({
        eventCategory: "GenresPage",
        eventAction: "View",
        eventName: `${selectedItem?.id}/${selectedItem?.title}`,
      });

      await sendTestMatomoEvent({
        eventCategory: "Genres",
        eventAction: "List",
        eventName: `${selectedItem?.id}/${selectedItem?.title}`,
      });
      break;

    case "continue_watching":
      await sendTestMatomoEvent({
        eventCategory: "ContinueWatching",
        eventAction: "ContentSelected",
        eventName: `${selectedItem?.show_id}/${selectedItem?.title}`,
      });
      break;

    case "content_language":
      await sendTestMatomoEvent({
        eventCategory: "Home",
        eventAction: "Select",
        eventName: `PopularLanguages(${selectedItem?.title})`,
      });

      await sendTestMatomoEvent({
        eventCategory: "LanguagePage",
        eventAction: "View",
        eventName: `${selectedItem?.id}/${selectedItem?.title}`,
      });

      await sendTestMatomoEvent({
        eventCategory: "Language",
        eventAction: "List",
        eventName: `${selectedItem?.id}/${selectedItem?.title}`,
      });
      break;

    case "aggregator":
      await sendTestMatomoEvent({
        eventCategory: "Home",
        eventAction: "Select",
        eventName: `${rowTitle}(${selectedItem?.title})`,
      });
      break;

    default:
      console.log("No matching playlist_type:", playlistType);
      break;
  }
};

// Home screen analytics (HomeScreen.js)

export const sendHomeScreenEvent = async (eventKey) => {

 await sendTestMatomoEvent({
    eventCategory: "HomePage",
    eventAction: "Select",
    eventName: eventKey,
  });
};

// Slider banner analytics (slider at the top of home screen)

export const sendSliderBannerEvent = async (sliderData, currentIndex) => {
  let categoryType;
  const selected = sliderData[0]?.list?.filter(
    (item) => item?.banner_type === 0
  )[currentIndex];

  console.log(sliderData[0]?.list, "selectedCategory");
  if (selected) {
    switch (selected.category_title) {
      case "Movies":
        categoryType = "Video";
        break;
      case "Shows":
        categoryType = "Video";
        break;
      case "TV channels":
        categoryType = "LiveChannel";
        break;
      case "Live":
        categoryType = "LiveEvent";
        break;
      case "Audio":
        categoryType = "Audio";
        break;
      case "Radio Channels":
        categoryType = "LiveRadio";
        break;

      case "Magazines and Journals":
        categoryType = "Pdf";
        break;

      case "Games":
        categoryType = "Games";
        break;
      default:
        categoryType = ""; // fallback
    }
    await sendTestMatomoEvent({
      eventCategory: "Banner",
      eventAction: "Select",
      eventName: `(${categoryType})/${selected.id}/${selected.title}`,
    });
  }
};
